export default function mpTabs() {
  document
    .querySelectorAll("[data-component='tabs']")
    .forEach((tabComponent, tabComponentIndex) => {
      const tabs = tabComponent.querySelectorAll("[role='tab']");
      const panels = tabComponent.querySelectorAll("[role='tabpanel']");

      // Initialize tabs and panels
      tabs.forEach((tab, index) => {
        const panelId =
          tab.getAttribute("id")?.replace("tab", "panel") ||
          `panel-${tabComponentIndex}-${index}`;

        tab.setAttribute("role", "tab");
        tab.setAttribute("aria-selected", index === 0 ? "true" : "false");
        tab.setAttribute("tabindex", index === 0 ? "0" : "-1");
        tab.setAttribute("aria-controls", panelId);
        tab.id ||= `tab-${tabComponentIndex}-${index}`;

        const panel = document.getElementById(panelId) || panels[index];
        if (panel) {
          panel.setAttribute("role", "tabpanel");
          panel.setAttribute("aria-labelledby", tab.id);
          panel.hidden = index !== 0;
        }
      });

      function updateTabVisibility() {
        tabs.forEach((tab) => {
          const panelId = tab.getAttribute("aria-controls");
          const panel = tabComponent.querySelector(`#${panelId}`);
          if (panel) {
            panel.hidden = tab.getAttribute("aria-selected") !== "true";
          }
        });
      }

      tabs.forEach((tab, index) => {
        tab.addEventListener("click", () => {
          tabs.forEach((t) => {
            t.setAttribute("aria-selected", "false");
            t.setAttribute("tabindex", "-1");
          });
          tab.setAttribute("aria-selected", "true");
          tab.setAttribute("tabindex", "0");
          tab.focus();
          updateTabVisibility();
        });

        tab.addEventListener("keydown", (e) => {
          let newIndex;
          if (e.key === "ArrowRight") {
            newIndex = (index + 1) % tabs.length;
            tabs[newIndex].click();
            e.preventDefault();
          } else if (e.key === "ArrowLeft") {
            newIndex = (index - 1 + tabs.length) % tabs.length;
            tabs[newIndex].click();
            e.preventDefault();
          } else if (e.key === "Home") {
            tabs[0].click();
            e.preventDefault();
          } else if (e.key === "End") {
            tabs[tabs.length - 1].click();
            e.preventDefault();
          }
        });
      });

      updateTabVisibility();
    });
}
